import SpitialSearch from "../../components/search/wrapper";
import RootLayout from "../layout";

const SearchPage = () => {
  return (
    <RootLayout>
      <SpitialSearch />
    </RootLayout>
  );
};
export default SearchPage;
